import { module as BaseModule } from 'modujs'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(ScrollTrigger, SplitText)

export default class extends BaseModule {
  init() {
    const { effect } = this.el.dataset
    this[effect]()
  }

  fade() {
    gsap.to(this.el, {
      autoAlpha: 1,
      duration: 1,
      ease: 'power2.inOut',
    })
  }

  intro() {
    const gradient = this.el.querySelector('.gradient')
    const tl = gsap.timeline({ paused: true })
    tl.fromTo(
      this.el,
      {
        backgroundColor: '#000',
        color: '#fff',
      },
      {
        backgroundColor: '#F4F4F4',
        color: '#F4F4F4',
        duration: 1,
      },
    )

    tl.fromTo(
      gradient,
      {
        '--tw-gradient-from': '#000',
      },
      {
        '--tw-gradient-from': '#F4F4F4',
        duration: 1,
      },
      '0',
    )

    ScrollTrigger.create({
      trigger: this.el,
      start: '50% 25%',
      end: 'bottom 25%',
      animation: tl,
      scrub: true,
    })
  }

  text() {
    const text = this.el.querySelector('.text')
    const split = new SplitText(text, { type: 'lines' })
    const { lines } = split

    const animation = gsap.timeline()
    animation.from(lines, {
      opacity: 0,
      stagger: 0.15,
      duration: 1.5,
    })

    const trigger = this.el
    ScrollTrigger.create({
      animation,
      trigger,
      start: 'start 75%',
      end: 'bottom bottom',
    })
  }

  textinstant() {
    const texts = this.el.querySelectorAll('p')

    texts.forEach((text) => {
      const split = new SplitText(text, { type: 'lines' })
      const { lines } = split

      const animation = gsap.timeline()
      animation.from(lines, {
        opacity: 0,
        stagger: 0.15,
        duration: 1.5,
      })
    })
  }
}
